export class BalanceDataInterestRate {
  balanceDataInterestRateId: number;
  interestRate: number;
  interestRateSource: string;
  interestRateSourceDocPath: string;
  adjustmentsTestedPartyBalanceDataId: number;
}
